import React from 'react'
import { InputFieldContainer } from './styles'
import NumberInput from 'components/Shared/Inputs/NumberInput'
import { LabelSize } from 'particles/Label'
import { BaseFieldProps } from './index'
import Text from 'particles/Text'
import { COUNTRY_ENUM } from 'services/api/constants'

interface NumberInputFieldProps extends BaseFieldProps {
    country?: COUNTRY_ENUM | null
    currencySign?: string | null
    isDisable?: boolean
    decimal?: boolean
    isReadOnly?: boolean
    min?: number
    footerText?: string
    identifier?: string
    labelSize?: LabelSize
    labelTooltip?: string
}
const NumberInputField: React.FC<NumberInputFieldProps> = ({
    name = '',
    title,
    subtitle,
    placeholder = '',
    country,
    currencySign,
    isRequired = false,
    isDisable = false,
    decimal = false,
    isReadOnly = false,
    min,
    width,
    footerText,
    identifier,
    ...props
}) => {
    return (
        <InputFieldContainer>
            <NumberInput
                {...props}
                name={name}
                placeholder={placeholder}
                currencySign={currencySign}
                country={country}
                isDisable={isDisable}
                isRequired={isRequired}
                width={width}
                decimal={decimal}
                isReadOnly={isReadOnly}
                min={min}
                title={title}
                subTitle={subtitle}
                identifier={identifier}
            />
            {footerText && (
                <Text scale="bodyS400" color="secondary" className="field-sub-title ">
                    {footerText}
                </Text>
            )}
        </InputFieldContainer>
    )
}
export default NumberInputField
